const dummyResponseDataForPetroHubUser = { // UserDetails Response{
  User: {
    UserID: 1819,
    FirstName: 'Shyam6',
    LastName: 'vir',
    Email: 'svir2506_6@yopmail.com',
    Active: true,
    Description: '',
    Language: '',
    LicenseNo: null,
    NameOnLicense: null,
    Flags: 2,
    DefaultRoleID: 379,
    CreatedOn: '2026-03-06T07:14:03Z',
    LastUpdatedOn: null,
    CreatedBy: '1200',
    LastUpdatedBy: null,
    Timezone: 'Africa/Accra',
    DateFormat: 'dd/MM/yyyy',
    DateTimeFormat: 'dd/MM/yyyy',
    UserType: 'Client',
    Salutation: '',
    Company: 'null',
    DefaultRoleName: null,
    ApplicationID: null,
    Signature: null,
    ESignature: null,
    StartDate: null,
    EndDate: null,
    CustomFields: null
  },
  UserObjects: [
    {
      UserObjectID: 40249,
      UserID: 1819,
      ObjectType: 'AssignedLocations',
      ObjectData: '[]',
      ApplicationID: 2
    },
    {
      UserObjectID: 40250,
      UserID: 1819,
      ObjectType: 'AssignedDivisions',
      ObjectData: '[9]',
      ApplicationID: 2
    },
    {
      UserObjectID: 40251,
      UserID: 1819,
      ObjectType: 'AssignedSourceSystems',
      ObjectData: '[11]',
      ApplicationID: 2
    },
    {
      UserObjectID: 40252,
      UserID: 1819,
      ObjectType: 'AssignedClients',
      ObjectData: '[]',
      ApplicationID: 2
    },
    {
      UserObjectID: 40253,
      UserID: 1819,
      ObjectType: 'AssignedProjects',
      ObjectData: '[]',
      ApplicationID: 2
    },
    {
      UserObjectID: 40254,
      UserID: 1819,
      ObjectType: 'AssignedSuppliers',
      ObjectData: '[]',
      ApplicationID: 2
    },
    {
      UserObjectID: 40255,
      UserID: 1819,
      ObjectType: 'AssociateContracts',
      ObjectData: '[]',
      ApplicationID: 2
    },
    {
      UserObjectID: 40256,
      UserID: 1819,
      ObjectType: 'FleetAssociates',
      ObjectData: '[]',
      ApplicationID: 2
    }
  ],
  UserRoles: [
    {
      UserToRoleID: 15884,
      RoleID: 379,
      Group1: '{"ID": "588697", "Text": "Almi Marine Management"}',
      Group2: '[{"ID": "27", "Text": "Home"}]',
      Group3: '[{"ID": "185661", "Text": "scenario_2"}]',
      Group4: null,
      Group5: null,
      OverrideRoleSetting: '[{"ID": "179", "Text": "Order"}]',
      RoleName: 'TestNewMax',
      Flags: null,
      RoleLevel: null
    }
  ],
  RoleClaims: [],
  Contacts: [
    {
      ContactID: 2011,
      FirstName: null,
      LastName: null,
      FullName: null,
      CompanyName: null,
      Phone: '98888888888',
      Email: null,
      Fax: null,
      BelongsTo: 'User',
      RecordID: '1819',
      Active: true,
      IsDefault: null,
      Flags: null,
      CreatedBy: '1819',
      CreatedOn: '2026-03-06T07:15:15',
      LastUpdatedBy: null,
      LastUpdatedOn: null
    }
  ],
  Addresses: [
    {
      AddressID: 60,
      AddressLine1: 'sdf',
      AddressLine2: 'sdaf',
      AddressLine3: 'df',
      City: 'sdaf',
      State: 'dfs',
      PostCode: '824201',
      Country: '',
      CountryName: '',
      AddressName: null,
      BelongsTo: 'User',
      RecordID: '1819',
      Active: true,
      IsDefault: true,
      Flags: null
    }
  ],
  UserToRoles: [
    {
      UserToRoleID: 15907,
      UserID: 1819,
      RoleID: 379,
      Active: true,
      IsDefault: null,
      Flags: null,
      CreatedOn: '2026-03-06T10:53:41',
      LastUpdatedOn: null,
      CreatedBy: '1200',
      LastUpdatedBy: null,
      ApplicationID: 2,
      Group1: '{"ID": "588697", "Text": "Almi Marine Management"}',
      Group2: '[{"ID": "27", "Text": "Home"}, {"ID": "27", "Text": "Home"}]',
      Group3: '[{"ID": "185661", "Text": "scenario_2"}, {"ID": "185660", "Text": "scenario_1"}]',
      Group4: null,
      Group5: null,
      OverrideRoleSetting: '[{"ID": "179", "Text": "Order"}, {"ID": "178", "Text": "Cylinder"}]',
      RoleName: 'TestNewMax',
      Level: null
    }
  ],
  Permissions: [
    {
      Code: 'cylinder',
      Options: [
        'S',
        'I',
        'M',
        'E',
        'D'
      ]
    },
    {
      Code: 'order',
      Options: [
        'S',
        'I',
        'M',
        'E',
        'D'
      ]
    },
    {
      Code: 'client',
      Options: [
        'S',
        'I',
        'E',
        'D'
      ]
    },
    {
      Code: 'um',
      Options: [
        'S',
        'I',
        'E',
        'D'
      ]
    },
    {
      Code: 'rm',
      Options: [
        'S',
        'I',
        'E',
        'D'
      ]
    }
  ],
};

export default dummyResponseDataForPetroHubUser;
